import React from 'react';
import { Eye, ListChecks, Network, Truck, KeyRound } from 'lucide-react';

const STEPS = [
  {
    n: '01',
    title: 'Assess',
    body: 'Physical walkthrough to determine project scope and sensitive items.',
    icon: Eye,
  },
  {
    n: '02',
    title: 'Sort',
    body: 'Guided decision-making to separate heirlooms from general debris.',
    icon: ListChecks,
  },
  {
    n: '03',
    title: 'Coordinate',
    body: 'Logistical planning for donations, sales, and deep cleaning.',
    icon: Network,
  },
  {
    n: '04',
    title: 'Execute',
    body: 'The operational phase: professional cleanout and junk removal.',
    icon: Truck,
  },
  {
    n: '05',
    title: 'Transition',
    body: 'Final readiness for sale, rental, or new occupant occupancy.',
    icon: KeyRound,
  },
];

export default function OurProcess() {
  return (
    <section
      className="section-pad bg-ohana-primary text-ohana-bg"
      data-testid="our-process-section"
    >
      <div className="container-ohana">
        <div className="max-w-3xl">
          <p className="overline !text-ohana-accent">Our Process</p>
          <h2
            className="h-display text-4xl md:text-5xl mt-3 leading-tight"
            data-testid="our-process-headline"
          >
            A 5-step guided process for clarity.
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-ohana-bg/80">
            Property transitions feel chaotic. Our framework replaces &ldquo;where do I even start?&rdquo; with a structured roadmap so you always know exactly what comes next.
          </p>
        </div>

        <ol
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-3"
          data-testid="our-process-steps"
        >
          {STEPS.map((step, i) => {
            const Ico = step.icon;
            return (
              <li
                key={step.n}
                className="relative rounded-2xl bg-ohana-primary-dark/60 backdrop-blur-sm border border-white/10 p-6 lg:p-5"
                data-testid={`our-process-step-${step.n}`}
              >
                <div className="flex items-center gap-3">
                  <span className="grid h-10 w-10 flex-none place-items-center rounded-xl bg-ohana-accent/15 text-ohana-accent">
                    <Ico className="h-5 w-5" />
                  </span>
                  <span className="font-serif text-3xl text-ohana-accent/70 leading-none">
                    {step.n}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-xl lg:text-2xl text-ohana-bg leading-tight">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-ohana-bg/75">
                  {step.body}
                </p>
                {i < STEPS.length - 1 && (
                  <span
                    aria-hidden="true"
                    className="hidden lg:block absolute top-9 -right-2 h-px w-4 bg-ohana-accent/40"
                  />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
